// extracted by mini-css-extract-plugin
export var chip = "_bq-0";
export var filterDropdown = "_bq-5";
export var filterItem = "_bq-6";
export var icon = "_bq-1";
export var removeButton = "_bq-3";
export var removeIcon = "_bq-4";
export var separator = "_bq-2";